module.exports = __webpack_public_path__ + "am.svg?7f0889c024d50d1d7830eb0a9f59aa09";